// extracted by mini-css-extract-plugin
export default {"layout":"layout_layout__M7BYw","contentWrapper":"layout_contentWrapper__E7-AR","card":"layout_card__AemUK","children":"layout_children__AEoJS"};